<template>
  <div>
    <div class="a2a_kit addToAny_box" :data-a2a-title="title" :data-a2a-url="url">
      <a class="a2a_button_facebook">
        <img src="@/assets/images/icon/facebook.png" alt />
        <span>
          {{ $t('promotion.referFriends.share') }}
        </span>
      </a>
      <a class="a2a_button_twitter">
        <img src="@/assets/images/icon/twitter.png" alt />
        <span>
          {{ $t('promotion.referFriends.share') }}
        </span>
      </a>
    </div>
    <component :is="'script'" src="https://static.addtoany.com/menu/page.js" async></component>
  </div>
</template>

<script>
export default {
  name: 'AddToAny',
  props: {
    url: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: () => {
        return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import './addToAny.scss';
</style>
